import React, { useEffect, useRef, useState } from "react";
import {
  Grid as KendoGrid,
  GridColumn as Column,
  GridPageChangeEvent,
  GridCustomHeaderCellProps,
  GridCustomCellProps,
  GridFilterChangeEvent,
  GridCellProps,
  GridRowProps,
} from "@progress/kendo-react-grid";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { Typography } from "@progress/kendo-react-common";
import { Button } from "@progress/kendo-react-buttons";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  HeaderThElement,
  PagerTargetEvent,
} from "@progress/kendo-react-data-tools";
import { LoadingPanel } from "../../components/layout/Loading";
import { settoDoActiveIndex, setToDoGUID } from "./toDoSlice";
import {
  CompositeFilterDescriptor,
  filterBy,
} from "@progress/kendo-data-query";
import { createToDo, getAllToDos } from "./services/toDo.services";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import AppDialog from "../../components/dialog/Dialog";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import FormRadioGroup from "../../components/formFields/FormRadioGroup";
import FormTextField from "../../components/formFields/FormTextField";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import FormDatePicker from "../../components/formFields/FormDateField";
import FormTimePicker from "../../components/formFields/FormTimeField";
import moment from "moment";
import IconButton from "../../components/common/IconButton";
import { FaEdit } from "react-icons/fa";
import { checkAcessRights } from "../../_helper/helper";
import { DELETE_ACCESS, EDIT_ACCESS } from "../../_contstants/common";
import CreateToDo from "./CreateToDo";

interface PageState {
  skip: number;
  take: number;
}

const initialDataState: PageState = { skip: 0, take: 10 };

const ToDo = () => {
  const gridRef = useRef<any>(null);
  const dispatch = useAppDispatch();
  const loading = useAppSelector((state) => state.todo.loading);
  const toDoActiveIndex = useAppSelector((state) => state.todo.toDoActiveIndex);
  const ToDoDetailList = useAppSelector((state) => state.todo.ToDoDetailList);

  const isEditAccess = checkAcessRights(location.pathname, EDIT_ACCESS);
  const isDeleteAccess = checkAcessRights(location.pathname, DELETE_ACCESS);

  const TODOList =
    toDoActiveIndex === 0
      ? ToDoDetailList?.ToDoTodayViewEntity || []
      : toDoActiveIndex === 1
      ? ToDoDetailList?.ToDoTomorrowViewEntity || []
      : ToDoDetailList?.ToDoUpcomingViewEntity || [];

  useEffect(() => {
    dispatch(getAllToDos());
  }, []);

  const [filter, setFilter] = React.useState<
    CompositeFilterDescriptor | undefined
  >(undefined);
  const [page, setPage] = React.useState<PageState>(initialDataState);
  const [pageSizeValue, setPageSizeValue] = React.useState<
    number | string | undefined
  >();

  const pageChange = (event: GridPageChangeEvent) => {
    const targetEvent = event.targetEvent as PagerTargetEvent;
    const take =
      targetEvent.value === "All" ? TODOList.length : event.page.take;

    if (targetEvent.value) {
      setPageSizeValue(targetEvent.value);
    }
    setPage({
      ...event.page,
      take,
    });
  };

  const handleFilterChange = (e: GridFilterChangeEvent) => {
    setFilter(e.filter);
    setPage({ skip: 0, take: page.take });
  };

  const MyEditCommandCell = (props: GridCellProps) => {
    const handleOpenDeleteDialog = (TitleGUID: string) => {
      dispatch(openDialog("updateToDo"));
      dispatch(setToDoGUID(TitleGUID));
    };

    return (
      <td
        className="action-td"
        style={{
          ...props.style,
        }}
      >
        <IconButton
          type="button"
          fillMode="flat"
          size="small"
          title="Edit"
          onClick={() => handleOpenDeleteDialog(props.dataItem.TitleGUID)}
        >
          <FaEdit className="absolute-position" style={{ fontSize: "24px" }} />
        </IconButton>
      </td>
    );
  };

  const HeaderCustomCell = (props: GridCustomHeaderCellProps) => (
    <HeaderThElement
      columnId={props.thProps?.columnId || ""}
      {...props.thProps}
      className={`table-header ${
        props.index === 5 || props.index === 6 || props.index === 7
          ? "locked-header"
          : ""
      }`}
    >
      {props.children}
    </HeaderThElement>
  );
  const CustomCell = (props: any) => {
    return (
      <td {...props.tdProps} colSpan={1} className={"table-cell"}>
        {props.children}
      </td>
    );
  };
  const MyDataCustomCell = (props: GridCustomCellProps) => (
    <CustomCell {...props} />
  );

  const handleTabChange = (index: number) => {
    dispatch(settoDoActiveIndex(index));
  };

  const handleAddTask = () => {
    dispatch(openDialog("addNewTask"));
  };

  const rowRender = (
    trElement: React.ReactElement<HTMLTableRowElement>,
    props: GridRowProps
  ) => {
    const ToDoStatus = props.dataItem.ToDoStatus;
    const notCompleted = { backgroundColor: "transparent" };
    const Completed = { backgroundColor: "#c5ebc5" };
    const trProps: any = { style: ToDoStatus ? Completed : notCompleted };
    let childrenArray: React.ReactNode[] = [];

    if (trElement.props.children) {
      if (trElement.props.children instanceof HTMLCollection) {
        childrenArray = Array.from(trElement.props.children).map(
          (child: any) => {
            return React.isValidElement(child) ? child : <>{child}</>;
          }
        );
      } else {
        childrenArray = [trElement.props.children];
      }
    }

    return React.cloneElement(trElement, { ...trProps }, childrenArray);
  };

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      <AddNewTaskDialog />
      <CreateToDo />
      <GridLayout cols={[{ width: "100%" }]}>
        <GridLayoutItem
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "4px 20px 20px 0",
          }}
        >
          <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
            Any.Do List
          </Typography.h4>
        </GridLayoutItem>
        <GridLayoutItem>
          <div
            style={{
              marginTop: 10,
              padding: "10px",
              border: "1px solid lightgray",
              borderRadius: "5px",
              boxShadow: "0 0 10px gainsboro",
            }}
          >
            <div className="d-flex gap-2 justify-content-between mt-1 mb-3">
              <div className="d-flex gap-2">
                <Button
                  themeColor={"primary"}
                  fillMode={toDoActiveIndex === 0 ? "solid" : "outline"}
                  onClick={() => handleTabChange(0)}
                >
                  Today
                </Button>
                <Button
                  themeColor={"primary"}
                  fillMode={toDoActiveIndex === 1 ? "solid" : "outline"}
                  onClick={() => handleTabChange(1)}
                >
                  Tomorrow
                </Button>
                <Button
                  themeColor={"primary"}
                  fillMode={toDoActiveIndex === 2 ? "solid" : "outline"}
                  onClick={() => handleTabChange(2)}
                >
                  Upcoming
                </Button>
              </div>
              <div>
                <Button
                  themeColor={"primary"}
                  fillMode={"solid"}
                  onClick={() => handleAddTask()}
                >
                  Add
                </Button>
              </div>
            </div>
            <KendoGrid
              rowRender={rowRender}
              style={{ maxHeight: "calc(100vh - 152px)" }}
              className="responsive-table"
              filterable={true}
              filter={filter}
              data={
                filter
                  ? filterBy(TODOList, filter).slice(
                      page.skip,
                      page.take + page.skip
                    )
                  : TODOList.slice(page.skip, page.take + page.skip)
              }
              onFilterChange={handleFilterChange}
              skip={page.skip}
              take={page.take}
              total={TODOList.length}
              pageable={{
                buttonCount: 5,
                pageSizes: [5, 10, 15, "All"],
                pageSizeValue: pageSizeValue,
                type: "input",
              }}
              onPageChange={pageChange}
              cells={{
                headerCell: HeaderCustomCell,
                data: MyDataCustomCell,
              }}
            >
              <Column
                field="Title"
                title="Title"
                width={300}
                cell={(props: any) => {
                  return (
                    <td
                      style={{
                        textDecoration: props.dataItem?.ToDoStatus
                          ? "line-through"
                          : "",
                      }}
                    >
                      {props.dataItem?.Title}
                    </td>
                  );
                }}
              />
              <Column field="Note" title="Note" width={300} />
              {(isEditAccess || isDeleteAccess) && (
                <Column
                  field="ID"
                  title="Actions"
                  cell={MyEditCommandCell}
                  width={"110px"}
                  filterable={false}
                  locked={true}
                />
              )}
            </KendoGrid>
          </div>
        </GridLayoutItem>
      </GridLayout>
    </>
  );
};

const AddNewTaskDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const loading = useAppSelector((state) => state.todo.loading);
  const toDoActiveIndex = useAppSelector((state) => state.todo.toDoActiveIndex);
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const [initialValues, serInitialValues] = useState({});

  useEffect(() => {
    if (toDoActiveIndex === 0) {
      serInitialValues({
        TaskTime: 1,
      });
    } else if (toDoActiveIndex === 1) {
      serInitialValues({
        TaskTime: 2,
      });
    } else if (toDoActiveIndex === 2) {
      serInitialValues({
        TaskTime: 3,
      });
    } else {
      serInitialValues({
        TaskTime: 1,
      });
    }
  }, [toDoActiveIndex]);

  const TaskTime = [
    {
      label: +moment().format("HH") >= 17 ? "Tomorrow Morning" : "This Evening",
      value: 1,
    },
    { label: "Tomorrow", value: 2 },
    { label: "Custom", value: 3 },
  ];

  const handleCloseBtn = async () => {
    dispatch(closeDialog());
  };

  const handleSubmit = async (values: any) => {
    const fetchDateTime = async () => {
      if (values?.TaskTime === 1) {
        if (+moment().format("HH") >= 17) {
          return `${moment().add(1, "days").format("YYYY-MM-DD")}T09:00:00`;
        } else {
          return `${moment().format("YYYY-MM-DD")}T06:00:00`;
        }
      } else if (values?.TaskTime === 2) {
        return `${moment().add(1, "days").format("YYYY-MM-DD")}T09:00:00`;
      } else {
        return `${moment(values?.ReminderDate).format("YYYY-MM-DD")}T${moment(
          values?.ReminderTime
        ).format("HH:mm:ss")}`;
      }
    };
    const reminder = await fetchDateTime();

    const payload = {
      Title: values?.Title ? values?.Title : "",
      Reminder: reminder || "",
      Note: "",
      IsActive: true,
    };
    const response = await dispatch(createToDo(payload));
    if (response.payload.Data.Status === 200) {
      dispatch(getAllToDos());
      dispatch(closeDialog());
    } else {
      dispatch(getAllToDos());
      dispatch(closeDialog());
    }
  };

  return (
    <>
      {dialogName === "addNewTask" && (
        <AppDialog>
          <Form
            onSubmit={handleSubmit}
            initialValues={initialValues}
            render={(formRenderProps: FormRenderProps) => (
              <FormElement style={{ width: "100%", minWidth: 500 }}>
                <Typography.h3 className="fw-bold">{"Add Task"}</Typography.h3>
                <hr className="mb-0" />
                <GridLayout>
                  <GridLayoutItem>
                    <Field
                      // wrapperClassName="d-flex flex-column checkBoxGroup-vertical"
                      // inputClassName="checkBoxGroup-vertical-input"
                      component={FormRadioGroup}
                      name={`TaskTime`}
                      layout="horizontal"
                      options={TaskTime}
                    />
                  </GridLayoutItem>
                  {formRenderProps.valueGetter("TaskTime") === 3 && (
                    <GridLayoutItem className="d-flex gap-2">
                      <Field
                        wrapperStyle={{
                          width: "100%",
                        }}
                        name="ReminderDate"
                        label="Date"
                        component={FormDatePicker}
                        minDate={moment().toDate()}
                        placeholder="Date"
                        validator={requiredValidator}
                        astrike={true}
                      />
                      <Field
                        wrapperStyle={{
                          width: "100%",
                        }}
                        name="ReminderTime"
                        label="Time"
                        min={
                          moment(
                            formRenderProps.valueGetter("ReminderDate")
                          ).format("YYYY-MM-DD") ===
                          moment().format("YYYY-MM-DD")
                            ? moment().toDate()
                            : undefined
                        }
                        component={FormTimePicker}
                        validator={requiredValidator}
                        astrike={true}
                      />
                    </GridLayoutItem>
                  )}
                  <GridLayoutItem>
                    <Field
                      id="Title"
                      name="Title"
                      label="Task Title"
                      placeholder="Add a task..."
                      component={FormTextField}
                      validator={requiredValidator}
                      astrike={true}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem
                    style={{
                      display: "flex",
                      justifyContent: "end",
                      marginTop: 20,
                    }}
                  >
                    <Button
                      themeColor={"primary"}
                      fillMode={"outline"}
                      style={{ marginRight: 10 }}
                      onClick={() => handleCloseBtn()}
                    >
                      Cancel
                    </Button>
                    <ButtonWithLoading
                      label={"Create"}
                      type="submit"
                      disabled={!formRenderProps.allowSubmit || loading}
                    />
                  </GridLayoutItem>
                </GridLayout>
              </FormElement>
            )}
          />
        </AppDialog>
      )}
    </>
  );
};

export default ToDo;
